module.exports = __webpack_public_path__ + "static/media/certificateIcon.412c5a44.svg";